import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

import globeIcon from "../../Assets/Icons/Others/globeIcon.svg";

import "./style.less";

const LNG_TOGGLE = [
  {
    label: "EN",
    value: "en",
  },
  {
    label: "BM",
    value: "ms",
  },
];

const LanguageToggle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(["routes"]);

  const [language, setLanguage] = useState("en");

  const onLanguageChange = async (region) => {
    setLanguage(region);
    const currentPath = location.pathname;
    const slugs = currentPath.split("/").filter((item) => item !== "");
    await i18next.changeLanguage(region);
    const newPath = slugs.map((slug) => {
      const translated = t(`slug-${slug}`);
      return translated.startsWith("slug-") ? slug : translated;
    });
    navigate(newPath.join("/"));
  };

  useEffect(() => {
    const slugs = location.pathname.split("/").filter((item) => item !== "");
    const storedLang = localStorage.getItem("i18nextLng");
    const currentLanguage =
      slugs?.[0] || (storedLang === "en-US" ? "en" : storedLang || "en");
    i18next.changeLanguage(currentLanguage);
    setLanguage(currentLanguage);
  }, []);

  return (
    <div className="language-toggle">
      <img src={globeIcon} alt="globeIcon" />
      <div className="button-box">
        <div className={`btn ${language}`} />
        {LNG_TOGGLE.map((item) => (
          <button
            type="button"
            className={`toggle-button ${
              language === item.value ? "active" : ""
            }`}
            onClick={() => onLanguageChange(item.value)}
            key={item.value}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageToggle;
